import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  // cart product update
  private cartSource = new BehaviorSubject<any>(localStorage.getItem('cart-count') || '0')
  cartData = this.cartSource.asObservable();
  
  // Points update
  private pointSource = new BehaviorSubject<any>(localStorage.getItem('points-balance') || '')
  pointData = this.pointSource.asObservable()

  private searchSource = new BehaviorSubject<any>('')
  searchData = this.searchSource.asObservable()
  menuRequested = false

  ngDoCheck(){
  }

  constructor(
    
    ) { 
      
    }

  changeCartData(data:any){
    localStorage.setItem('cart-count', data != null ? String(data) : '0')
    this.cartSource.next(data)
  }

  changePointData(data:any){
    if (data === undefined || data === null || data === '') {
      return
    }
    localStorage.setItem('points-balance', String(data))
    this.pointSource.next(data)
  }

  changeSearchData(data:any){
    this.searchSource.next(data)
  }

  requestMenu() {
    this.menuRequested = true
  }

}
